import AreaInput from 'components/area-input';
import YearInput from 'components/year-input';
import PriceInput from 'components/price-input';
import PercentInput from 'components/percent-input';
import Slider, { SliderProps } from 'components/slider';
import ClearInputButton from 'components/clear-input-button';
import { MaskedNumberInputProps } from 'components/masked-number-input';

import styles from './styles.module.scss';
import DayInput from 'components/day-input';
import PriceSqMInput from 'components/price-input-sqm';

type InputVariant = 'price' | 'area' | 'percent' | 'year' | 'day' | 'priceSqM';

export type InputWithSliderProps = {
  inputVariant: InputVariant;
  header?: string;
} & Pick<MaskedNumberInputProps, 'value' | 'onChange' | 'placeholder'> &
  Pick<SliderProps, 'min' | 'max' | 'step'>;

export const inputVarMap: Record<InputVariant, { component: React.FC<MaskedNumberInputProps> }> = {
  price: {
    component: PriceInput,
  },
  priceSqM: {
    component: PriceSqMInput,
  },
  area: {
    component: AreaInput,
  },
  percent: {
    component: PercentInput,
  },
  year: {
    component: YearInput,
  },
  day: {
    component: DayInput,
  },
};

const InputWithSlider: React.FC<InputWithSliderProps> = (props) => {
  const { value, min, max, step, placeholder, onChange, header, inputVariant } = props;

  const InputComponent = inputVarMap[inputVariant].component;

  return (
    <div className={styles.container}>
      <InputComponent value={value} label={header} onChange={onChange} placeholder={placeholder} />

      {/* <Slider value={value ?? 0} min={min} max={max} step={step} onChange={onChange} /> */}

      <ClearInputButton onClick={() => onChange()} />
    </div>
  );
};

export default InputWithSlider;
